import React from "react";

import "./GridBox.scss";

export class GridBox extends React.Component {
  render() {
    const onClick = (e) => {
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    };
    return (
      <div className="grid-box" onClick={onClick}>
        <h1 className="grid-box__title">{this.props.title}</h1>

        <p className="content">{this.props.content}</p>

        <div className="footer">{this.props.footer}</div>
      </div>
    );
  }
}
